module.exports = __webpack_public_path__ + "static/Icons_DownpAssist_active-ae701667c36852d7ebd776ef42e14fc4.png";